var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eN2aQMcLXV11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.441077,64.688301c-5.898812,33.145973-28.432157,69.58644-65.488901,80.700255C120.468916,169.884337,141.179836,218.080325,150,241.78053c14.961824-38.256477,37.273409-87.148557,68.531168-96.391974-49.41423-19.402435-66.645617-62.150175-67.090091-80.700255Z",
    transform: "matrix(1.774035 0 0 1.633274-119.834179-100.273786)",
    stroke: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2ba4c2e173b03ec7a385aceb6abf67be.svg";
export { ForwardRef as ReactComponent };